import { render, staticRenderFns } from "./CanvasQuadrant.vue?vue&type=template&id=b1655cd6&"
import script from "./CanvasQuadrant.vue?vue&type=script&lang=js&"
export * from "./CanvasQuadrant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports